import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import moment from 'moment'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import {
  INSURANCE_COMPANIES_URL,
  INSURANCE_BROKERS_URL
} from 'constants'

import RetractablePanel from 'components/RetractablePanel'

import EditForm from './EditForm'
import NewPolicy from './NewPolicy'

import { edittingPolicyChanged } from 'scenes/VehicleDetail/components/Policy/actions'

import './styles.scss'


export class PolicyData extends BaseComponent {

  constructor(props) {
    super(props)

    this.state = {
      companies: [],
      brokers: []
    }
    this.DATE_FORMAT = 'YYYY-MM-DD'
    this.today = moment().format('YYYY-MM-DD')
    this._bind( '_renderHeaderActions', '_onEdit', '_renderData', '_renderEditForm',
                '_fetchInsuranceCompanies', '_fetchBrokers', '_downloadPolicy', '_openNewPolicyModal')
  }

  _convertToOptions = (object) => ({ value: object.id, label: object.name })

  componentDidMount() {
    this.props.edittingPolicyChanged(false)
    this._fetchInsuranceCompanies()
    this._fetchBrokers()
  }

  _fetchInsuranceCompanies() {
    request(INSURANCE_COMPANIES_URL)
    .then((res) => {
      const companies = res.companies.map(this._convertToOptions)
      this.setState({ companies })
    })
  }

  _fetchBrokers() {
    request(INSURANCE_BROKERS_URL)
    .then((res) => {
      const brokers = res.brokers.map(this._convertToOptions)
      this.setState({ brokers })
    })
  }

  _onEdit(evt) {
    evt.preventDefault()
    this.panel.open()
    this.props.edittingPolicyChanged(true)
  }

  _downloadPolicy() {
    window.open(this.props.policy.file)
  }

  _openNewPolicyModal() {
    this.props.edittingPolicyChanged(false)
    this.context.toggleModal(
      true,
      <NewPolicy
        userId={this.props.userId}
        vehicleId={this.props.vehicleId}
        policyId={this.props.policyId}
        extraData={this.props.extra_data}
        refreshExtraData={this.props.refreshExtraData}
      />
    )
  }

  _renderHeaderActions() {
    return !this.props.editting ? (
      <div className="header-icons">
        <button onClick={this._downloadPolicy}>
          <i className="material-icons">file_download</i>
        </button>
        <button onClick={this._onEdit}>
          <i className="material-icons">edit</i>
        </button>
      </div>
    ) : (
      <div className="header-icons">
        <button onClick={this._openNewPolicyModal} type="button" className="btn btn-outline-warning renew-button">Renovar póliza</button>
        <button onClick={this._downloadPolicy}>
          <i className="material-icons">file_download</i>
        </button>
      </div>
    )
  }

  _renderEditForm() {
    return (
      <EditForm
        {...this.props}
        companies={this.state.companies}
        brokers={this.state.brokers}
      />
    )
  }

  _renderData() {
    const policy = this.props.policy
    return (
      <div className="PolicyData__data">
        <div>
          <span>Número de poliza:</span>
          <strong>{policy.number}</strong>
        </div>
        <div>
          <span>Aseguradora:</span>
          <strong>{policy.company}</strong>
        </div>
        <div>
          <span>Fecha de expedición:</span>
          <strong>{policy.issued_date}</strong>
        </div>
        <div>
          <span>Fecha de vigencia:</span>
          <strong>{policy.expiration_date}</strong>
        </div>
        <div>
          <span>Agente Asegurador:</span>
          <strong>{policy.broker}</strong>
        </div>
        <div>
          <span>Nombre del titular:</span>
          <strong>{policy.holder_name}</strong>
        </div>
        <div>
          <span>Frecuencia de pago:</span>
          <strong>{policy.periodicity_type}</strong>
        </div>
        <div>
          <span>Cobertura:</span>
          <strong>{policy.coverage}</strong>
        </div>
      </div>
    )
  }

  render() {
    const renderer = this.props.editting ? this._renderEditForm : this._renderData
    return (
      <RetractablePanel
        ref={(panel) => this.panel = panel}
        name="Datos de la poliza"
        actionButtons={this._renderHeaderActions()}
        isToggle={false}
      >
        { renderer() }
      </RetractablePanel>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    policy: state.vehicleDetail.get('policy').toJS(),
    editting: state.policyVehicleDetail.get('editting')
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    edittingPolicyChanged: (editting) => dispatch(edittingPolicyChanged(editting))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PolicyData)


PolicyData.propTypes = {
  userId: PropTypes.string.isRequired,
  vehicleId: PropTypes.string.isRequired,
  policyId: PropTypes.number.isRequired
}

PolicyData.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Policy/PolicyData/index.js